import '../styles/footer.css';
const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">

        {/* 1. Bölüm: İletişim */}
        <div className="footer-section">
          <h3>İletişim</h3>
          <div className='Contacts'>
            <p><strong>M.ZEIN ZAMMAR</strong></p>
            <p>(Bi Teklifle Hizmet pazaryeri)</p>
            <p>📍 Bahcelievler / İstanbul</p>
            <p>📞 +90 551 075 71 52</p>
            <p>📞 +90 552 498 51 35</p>
            <p>✉️ contact@biteklifle.com</p>
          </div>
        </div>

        {/* 2. Bölüm: Kurumsal ve Yasal Metinler (İyzico için ŞART) */}
        <div className="footer-section">
          <h3>Kurumsal</h3>
          <nav className="footer-nav">
            <a href="/kullanim-kosullari">Üyelik Sözleşmesi</a>
            <a href="/hizmet-alan-sozlesmesi">Hizmet Alan Sözleşmesi</a>
            <a href="/hizmet-veren-sozlesmesi">Hizmet Veren Sözleşmesi</a>
            <a href="/kvkk-aydinlatma-metni">KVKK Politikası</a>
            <a href="/acik-riza-metni">Açık Rıza Metni</a>
            <a href="/iptal-ve-iade">İade Koşulları</a>
            <a href="/mesafeli-satis-sozlesmesi">Mesafeli Satış Sözleşmesi</a>
          </nav>
        </div>

        {/* 3. Bölüm: Takip ve Ödeme Logoları */}
        <div className="footer-section">
          <h3>Güvenli Ödeme</h3>
          <div className="payment-area">
            {/* iyzico logosu ve kart logoları buraya gelecek */}
            <div className="payment-logo-wrapper">
              <img
                src="/logo_band_colored@2x.png"
                alt="iyzico ile guvenli odeme"
                className="footer-payment-logo"
              />
            </div>

            {/* <div className="iyzico-wrapper">
              <img 
                src="/images/iyzico_ile_ode_colored.svg" 
                alt="iyzico ile Güvenli Ödeme" 
                className="footer-iyzi-logo" 
              />
            </div> */}

            <div className="card-icons">
              <img src="https://img.icons8.com/color/48/000000/visa.png" alt="Visa" />
              <img src="https://img.icons8.com/color/48/000000/mastercard.png" alt="Mastercard" />
              {/* <img src="https://img.icons8.com/color/48/000000/maestro.png" alt="Maestro" />
            <img src="https://img.icons8.com/color/48/000000/troy.png" alt="Troy" /> */}
            </div>
          </div>
          <h3 style={{ marginTop: '15px' }}>Bizi Takip Edin</h3>
          <div className="social-links">
            <a href="https://www.instagram.com/biteklifle/" target="_blank" rel="noreferrer">Instagram</a>
            <a href="#">Facebook</a>
          </div>
        </div>
      </div>

      <div className="footer-bottom">
        © 2025 Bi Teklifle. Tüm hakları saklıdır.
      </div>
    </footer>
  );
};

export default Footer;


